import type Invitation from "../model/Invitation";
import API, { responseOf } from "./base";

export const membersByOrganization = (
  organizationId: string,
  filter?: string,
): Promise<Invitation[]> =>
  responseOf(
    API.get(`/invitations/byOrganizationId/${organizationId}/members`, {
      params: { filter },
    }),
  );

export const accountsByOrganization = (
  organizationId: string,
): Promise<Invitation[]> =>
  responseOf(
    API.get(`/invitations/byOrganizationId/${organizationId}/accounts`),
  );

export const create = (invitation: Invitation): Promise<Invitation> =>
  responseOf(
    API.post("/invitations", { ...invitation, origin: location.origin }),
  );

export const resend = async (invitationId: string): Promise<void> => {
  await API.post(`/invitations/${invitationId}/resend`, {
    origin: location.origin,
  });
};

export const byTargetUserId = (userId: string): Promise<Invitation[]> =>
  responseOf(API.get(`/invitations/byTargetUserId/${userId}`));

export const get = (invitationId: string): Promise<Invitation> =>
  responseOf(API.get(`/invitations/${invitationId}`));

export const accept = async (invitationId: string): Promise<void> => {
  await API.post(`/invitations/${invitationId}/accept`);
};

const remove = async (invitationId: string): Promise<void> => {
  await API.delete(`/invitations/${invitationId}`);
};
export { remove as delete };

export const assignRole = async (
  roleId: string,
  invitationId: string,
): Promise<void> => {
  await API.post(`/invitations/${invitationId}/assign/${roleId}`);
};

export const unassignRole = async (
  roleId: string,
  invitationId: string,
): Promise<void> => {
  await API.post(`/invitations/${invitationId}/unassign/${roleId}`);
};
